import type {ClientSpecMap, PagesPlatformApplications} from '@wix/document-services-types'
import _ from 'lodash'

export const replaceWixCodeAppId = (
    pagesPlatformApplications: PagesPlatformApplications,
    clientSpecMap: ClientSpecMap
) => {
    const wixCodeAppId = _.chain(clientSpecMap).find({type: 'siteextension'}).get(['appDefinitionId']).value()
    pagesPlatformApplications[wixCodeAppId] = _.assign({}, pagesPlatformApplications.wixCode)
    delete pagesPlatformApplications.wixCode
}

export const transformPagePlatformApplicationByPage = (pagesPlatformApplications: PagesPlatformApplications) => {
    return _.transform(
        pagesPlatformApplications,
        (result, pageIds, appId) => {
            _.forOwn(pageIds, (value, pageId) => {
                result[pageId] = result[pageId] || []
                result[pageId].push(appId)
            })
        },
        {}
    )
}
